export type BundleComponentType = 'addon' | 'cake';

export interface BundleComponentItem {
  id: string;
  componentType: BundleComponentType;
  productId: string;
  labelEn: string;
  labelAr: string;
  qty: number;
  unitPrice: number;
}

export interface BundleVariantOption {
  id: string;
  productId?: string;
  labelEn: string;
  labelAr: string;
  previewUrl: string;
  qty: number;
  price: number;
}

export interface BundleVariantGroup {
  id: string;
  labelEn: string;
  labelAr: string;
  isRequired: boolean;
  selectionType: 'single' | 'multiple';
  maxSelections: number;
  activeState: boolean;
  expanded: boolean;
  options: BundleVariantOption[];
}

export const createLocalId = (): string =>
  `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
